<template>
    <div class="items">
        <div class="page_header">
            <div class="page_header--title">
                Абонементы и услуги
            </div>
            <div class="page_header--control">
                <div class="items_navs">
                    <div
                        class="items_nav"
                        :class="{active: activeTab === 'active'}"
                        @click="activeTab = 'active'">
                        Действующие
                    </div>
                    <div
                        class="items_nav"
                        :class="{active: activeTab === 'finished'}"
                        @click="loadFinishedItems(); activeTab = 'finished'">
                        Истекшие
                    </div>
                </div>
            </div>
        </div>

        <div class="page_content">
            <div class="items_tabs">
                <div
                    class="items_tab"
                    :class="{active: activeTab === 'active'}"
                >
                    <items-list
                        :items="items"
                        :items-type="'mixed'"
                    />
                </div>
                <div
                    class="items_tab"
                    :class="{active: activeTab === 'finished'}"
                >
                    <items-list
                        :items="finishedItems"
                        :items-type="'mixed'"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ItemsList from "../components/ItemsList";

    export default {
        name: 'Items',
        components: { ItemsList },
        data() {
            return {
                activeTab: 'active',
            }
        },
        computed: {
            items: function(){
                return this.$store.getters.items;
            },
            finishedItems: function() {
                return this.$store.getters.finishedItems;
            },
        },
        methods: {
            loadFinishedItems(){
                if (this.$store.getters.finishedItems.length === 0){
                    this.$store.dispatch('loadFinishedContracts')
                    this.$store.dispatch('loadFinishedServices')
                }
            }
        },
        created() {
            if (this.$store.getters.contracts.length === 0){
                this.$store.dispatch('loadContracts')
            }
            if (this.$store.getters.services.length === 0){
                this.$store.dispatch('loadServices')
            }
        }
    }
</script>
